export const actionTypes = {
    SET_THEME: 'SET_THEME',
    SET_LIKE: 'SET_LIKE',
    FETCH_STORY_IDS_REQUEST: 'FETCH_STORY_IDS_REQUEST',
    FETCH_STORY_IDS_SUCCESS: 'FETCH_STORY_IDS_SUCCESS',
    FETCH_STORY_IDS_FAILURE: 'FETCH_STORY_IDS_FAILURE',
    FETCH_STORIES_REQUEST: 'FETCH_STORIES_REQUEST',
    FETCH_STORIES_SUCCESS: 'FETCH_STORIES_SUCCESS',
    FETCH_STORIES_FAILURE: 'FETCH_STORIES_FAILURE',
};
